<template>
  <div class="d-block">
    <div class="post_gallery_play" @click="handleClick">
      <div 
        class="bg-image"
        :style="{ backgroundImage: `url(${datas.coverurl})` }"
      ></div>
      <div class="post__gallery_play_content" style="z-index: 10">
        <div class="title">
          {{ datas.title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { clickPlacement } from '@/api/placement.js';
export default {
  props: ["datas"],
  methods: {
    handleClick() {
      const url = clickPlacement(this.datas.id, this.datas);
      window.open(url, '_blank');
    }
  }

};
</script>

<style scoped>
/* 添加容器定位和宽度约束 */
.post_gallery_play {
  position: relative; 
  width: 100%; 
  max-width: 100%;
  /* 添加固定高度或按比例设置高度 */
  height: 240px; /* 根据需求调整具体数值 */
}

.post_gallery_play .bg-image {
  left: 0;
  top: 0;
  z-index: -1;
}

.custom-img {
  width: 100%;
  height: auto;
  /* 保持图片比例，缩放图片直至完全覆盖容器，超出部分会被裁剪 */
  object-fit: cover;
  /* 确保图片中心部分显示在容器中 */
  object-position: 50% 50%; 
}
.post_gallery_play .post__gallery_play_content .title{
  font-size: 12px;
  color: #fff;
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;
  background-color: rgba(0,0,0,0.3);
  padding: 1px 10px;
  box-sizing: border-box; /* 新增：内边距计入宽度计算 */
}

/* 添加链接元素样式，确保继承溢出控制 */
.post_gallery_play .post__gallery_play_content .title a {
  display: block;
  width: 100%;
  white-space: inherit;
  overflow: inherit;
  text-overflow: inherit;
}

/* 新增：标题底部渐变阴影 */
.title {
  position: relative;
  padding-bottom: 15px;
  width: 100%;
}

.title::after {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 30px; /* 阴影高度 */
  /* 从透明到半黑的渐变，增强文字可读性 */
  background: linear-gradient(to top, rgba(0, 0, 0, 0.5), transparent);
  pointer-events: none; /* 不影响点击交互 */
}

/* 移除父容器内边距，确保背景色边缘对齐图片 */
.post__gallery_play_content {
  padding: 0 !important;
}
</style>